
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoTemplateMissingDocumentNoteModalTemplate } from 'themes/application/niko-patient/components';
import { NikoTemplateMissingDocumentNoteModalStore } from '../stores';

@setCurrentView((rootStore, componentProps) => new NikoTemplateMissingDocumentNoteModalStore(rootStore, componentProps), 'nikoTemplateMissingDocumentNoteModalStore')
@observer
class NikoTemplateMissingDocumentNoteModal extends React.Component {
    render() {
        return <NikoTemplateMissingDocumentNoteModalTemplate {...this.props} />
    }
}

export default NikoTemplateMissingDocumentNoteModal;
